import { useContext, createContext } from 'react'
import mapboxgl from 'mapbox-gl'
import { MapStyle } from 'src/types/map'

type MapboxMapContextValue = {
  map: mapboxgl.Map
  style: MapStyle
}
export const MapboxMapContext = createContext<MapboxMapContextValue>({} as any)
export const useMap = (): mapboxgl.Map => {
  const { map } = useContext(MapboxMapContext)
  return map
}

export const useMapStyle = (): MapStyle => {
  const { style } = useContext(MapboxMapContext)
  return style
}

export const DARK_MAP_STYLES = [MapStyle.DARK, MapStyle.SATELLITE]
export const useMapStyleMode = (): 'light' | 'dark' => {
  const { style } = useContext(MapboxMapContext)
  return DARK_MAP_STYLES.includes(style) ? 'dark' : 'light'
}
